import { Balance, Transaction } from "../types";

export const dailyBalance = (transactions: Transaction[]): Balance[] => {

  const reducedTransactions = transactions.reduce((acc, tr) => {
    const {date, type, amount} = tr;

    // dateがundefinedの場合はスキップ
    if (!date) return acc;

    if (!acc[date]) {
      acc[date] = { date, income: 0, expense: 0, balance: 0 };
    }
    if (type === "income") {
      acc[date].income += amount;
    } else {
      acc[date].expense += amount;
    }
    acc[date].balance = acc[date].income - acc[date].expense; 

    return acc;
  }, {} as Record<string, Balance>)

  return Object.values(reducedTransactions).sort((a, b) => 
    new Date(a.date!).getTime() - new Date(b.date!).getTime()
  );
}